import { Injectable } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Events } from '@df/core/service/event';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { NBuilderConfig } from '../common/builder.config';
import { NBuilderProductsSetup } from '../common/products-setup/builder-products-setup.config';
import { NKitGeneralSetup } from './general-setup/kit-general-setup.config';
import { NKitBuilder } from './page-kit-builder-view.component';
@Injectable({
    providedIn: 'root'
})
export class KitBuilderService {
    constructor(
        private productResource: ProductResource,
        private events: Events
    ) {}
    getProducts(data: NKitBuilder.IStorageData, useToyAttr: boolean, sectionOptionId: number): LocalProduct<IProductDataV2>[] {
        return (this.productResource.getAllExisting() as LocalProduct<IProductDataV2>[]).filter(
            (product: LocalProduct<IProductDataV2>) =>
                (useToyAttr ? product.data!.toy_eligible_builder : product.data!.eligible_builder) &&
                this.isBuilderProduct(product, sectionOptionId)
        ) as LocalProduct<IProductDataV2>[];
    }
    loadAllProducts(baseOnToyAttr: boolean) {
        return this.productResource.find({
            filter: baseOnToyAttr ? { toy_eligible_builder: 1 } : { eligible_builder: 1 },
            verbosity: 2
        });
    }
    loadSectionProducts(ponyOptions: NKitGeneralSetup.ISetupElementData[]) {
        return this.productResource.loadAllIds(
            ponyOptions.map(o => o.productId),
            2,
            { safe: true }
        );
    }
    removeRedundantData(data: NKitBuilder.IStorageData): void {
        if (data.step === NKitBuilder.ESteps.pony) {
            this.resetProductStep(data);
        }
    }
    goToStep(data: NKitBuilder.IStorageData, step?: NKitBuilder.ESteps): void {
        data.step = step !== undefined ? step : NKitBuilder.ESteps.pony;
        this.removeRedundantData(data);
        this.events.broadcast(NBuilderConfig.updateStorageEvent);
    }
    validateData(data: NKitBuilder.IStorageData, ponyOptions: NKitGeneralSetup.ISetupElementData[]): boolean {
        if (!data.pony) {
            return false;
        }
        const productId = ponyOptions.find(o => o.name === data.pony!.optionName)?.productId;
        if (!productId) {
            return false;
        }
        return this.productResource.getExisting(productId)?.isSalable() || false;
    }
    private isBuilderProduct(product: LocalProduct<IProductDataV2>, sectionOptionId: number): boolean {
        return (
            this.productHasSectionOption(product, sectionOptionId) &&
            (product.isConfigurable ? !!product.children.find(p => p.isSalable()) : product.isSalable())
        );
    }
    private productHasSectionOption(product: LocalProduct<IProductDataV2>, optionId: number): boolean {
        return product.getAttr<number[]>(NBuilderProductsSetup.SECTION_OPTION_ATTR_ID)?.includes(optionId);
    }
    private resetProductStep(data: NKitBuilder.IStorageData): void {
        data.pony = undefined;
        data.selection = {};
    }
}
